import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';

const THICKNESS = {
  MEDIUM: 'medium',
  SMALL: 'small',
};

// Default stages in percentage
const STAGE_ONE = 37.5;
const STAGE_TWO = 57;

const ProgressBar = ({ children, value, maxValue, className, thickness, palette }) => {
  const content = children || null;
  let barClasses = null;
  const valueInPercent = (value / maxValue) * 100;

  if (palette) {
    barClasses = generateColors(palette, valueInPercent, thickness);
  } else {
    barClasses = classnames(
      'fr-progress__percentage',
      {
        'fr-progress__percentage--blue': valueInPercent <= STAGE_ONE,
        'fr-progress__percentage--red': valueInPercent > STAGE_TWO,
        'fr-progress__percentage--yellow': valueInPercent > STAGE_ONE && valueInPercent <= STAGE_TWO,
      },
      `fr-progress__percentage--${thickness}`,
    );
  }

  return (
    <div className={classnames('fr-progress', className)}>
      <div className={classnames('fr-progress__bar', `fr-progress__bar--${thickness}`)}>
        <span className={barClasses} style={{ width: `${valueInPercent}%` }} />
      </div>
      {content}
    </div>
  );
};

const generateColors = (palette, valueInPercent, thickness) => {
  let activeBar = null;

  for (const key in palette) {
    const range = key.split('-');
    if (range.length === 2) {
      const percentFrom = parseInt(range[0]);
      const percentUntil = parseInt(range[1]);
      if (valueInPercent >= percentFrom && valueInPercent <= percentUntil) {
        activeBar = palette[key];
      }
    }
  }

  return classnames('fr-progress__percentage', `fr-progress__percentage--${thickness}`, activeBar);
};

ProgressBar.propTypes = {
  // show some additional information below of progress bar.
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  maxValue: PropTypes.number.isRequired,
  /**
   * If you want to override progress bar colors use palette prop. example:
   * {
   *  '0-25': 'someClassName_1',
   *  '25-75': 'someClassName_2',
   *  '75-100': 'someClassName_3'
   * }
   */
  palette: PropTypes.object,

  thickness: PropTypes.oneOf(Object.values(THICKNESS)),

  value: PropTypes.number.isRequired,
};

ProgressBar.defaultProps = {
  thickness: THICKNESS.SMALL,
};

export default ProgressBar;
